<template>
    <div v-if="mostrar" class="modal-mask" @click="$emit('fechar')">
        <div class="modal-container modal-objetivos" @click.stop>
            <div class="modal-objetivos__cabecalho">
                <h3 class="titulo">Objetivos estratégicos</h3>
            </div>
            <hr>

            <form class="modal-objetivos__form" @submit.prevent="salvar">
                <label for="objetivo-nome">{{ editandoId ? 'Editar objetivo' : 'Novo objetivo' }}</label>
                <div class="modal-objetivos__linha">
                    <input
                        id="objetivo-nome"
                        v-model="nome"
                        type="text"
                        class="form-control"
                        maxlength="255"
                        placeholder="Nome do objetivo estratégico"
                        required
                    >
                    <button type="submit" class="btn-salvar" :disabled="salvando || !nome.trim()">
                        {{ editandoId ? 'Atualizar' : 'Adicionar' }}
                    </button>
                    <button v-if="editandoId" type="button" class="btn-cancelar" @click="cancelarEdicao">
                        Cancelar
                    </button>
                </div>
            </form>

            <div v-if="carregando" class="modal-objetivos__vazio">Carregando…</div>
            <div v-else-if="!lista.length" class="modal-objetivos__vazio">
                Nenhum objetivo cadastrado.
            </div>
            <ul v-else class="modal-objetivos__lista">
                <li v-for="item in lista" :key="item.id">
                    <span class="modal-objetivos__nome" :title="item.nome">{{ item.nome }}</span>
                    <div class="modal-objetivos__acoes">
                        <i
                            class="bi-pencil-square"
                            title="Editar"
                            role="button"
                            @click="iniciarEdicao(item)"
                        ></i>
                        <i
                            class="bi-trash"
                            title="Excluir"
                            role="button"
                            @click="excluir(item)"
                        ></i>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { useApiError } from "@/composables/useApiError";
import servicePCM from "@/services/servicePCM";

export default {
    name: "ModalCrudObjetivosEstrategicos",
    props: {
        mostrar: { type: Boolean, default: false },
    },
    emits: ["fechar", "alterado"],
    setup() {
        const { handleError } = useApiError();
        return { handleApiError: handleError };
    },
    data() {
        return {
            lista: [],
            nome: "",
            editandoId: null,
            carregando: false,
            salvando: false,
        };
    },
    watch: {
        async mostrar(visivel) {
            if (visivel) {
                this.cancelarEdicao();
                await this.carregar();
            }
        },
    },
    methods: {
        async carregar() {
            this.carregando = true;
            try {
                const data = await servicePCM.listarObjetivosEstrategicos();
                this.lista = Array.isArray(data) ? data : [];
            } catch (error) {
                this.handleApiError(error);
                this.lista = [];
            } finally {
                this.carregando = false;
            }
        },
        iniciarEdicao(item) {
            this.editandoId = item.id;
            this.nome = item.nome ?? "";
        },
        cancelarEdicao() {
            this.editandoId = null;
            this.nome = "";
        },
        async salvar() {
            const nome = this.nome.trim();
            if (!nome || this.salvando) return;

            this.salvando = true;
            try {
                if (this.editandoId) {
                    await servicePCM.atualizarObjetivoEstrategico(this.editandoId, { nome });
                } else {
                    await servicePCM.criarObjetivoEstrategico({ nome });
                }
                this.cancelarEdicao();
                await this.carregar();
                this.$emit("alterado");
            } catch (error) {
                this.handleApiError(error);
            } finally {
                this.salvando = false;
            }
        },
        async excluir(item) {
            if (!confirm(`Excluir o objetivo "${item.nome}"?`)) return;
            try {
                await servicePCM.excluirObjetivoEstrategico(item.id);
                if (this.editandoId === item.id) {
                    this.cancelarEdicao();
                }
                await this.carregar();
                this.$emit("alterado");
            } catch (error) {
                this.handleApiError(error);
            }
        },
    },
};
</script>

<style scoped>
.modal-mask {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.55);
}

.modal-objetivos {
    max-width: 640px;
    width: 90%;
    max-height: 80%;
    overflow: auto;
    padding: 1.75rem 2rem;
    background: var(--cor-fundo, #fff);
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

.modal-objetivos__cabecalho {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.modal-objetivos__cabecalho .titulo {
    margin: 0;
}

.modal-objetivos__form {
    margin: 1rem 0 1.25rem;
}

.modal-objetivos__form label {
    display: block;
    margin-bottom: 0.35rem;
    font-weight: 600;
}

.modal-objetivos__linha {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.modal-objetivos__linha .form-control {
    flex: 1;
}

.btn-salvar {
    height: 2.5rem;
    padding: 0 1rem;
    background-color: #f89e31;
    border: none;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    white-space: nowrap;
}

.btn-salvar:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-cancelar {
    height: 2.5rem;
    padding: 0 0.85rem;
    background: transparent;
    border: 1px solid var(--cor-separador, #ccc);
    border-radius: 4px;
    cursor: pointer;
}

.modal-objetivos__vazio {
    padding: 1rem 0;
    color: var(--cor-fonte-fraca, #888);
}

.modal-objetivos__lista {
    list-style: none;
    margin: 0;
    padding: 0;
}

.modal-objetivos__lista li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 0.65rem 0;
    border-bottom: 1px dashed var(--cor-separador, #ddd);
}

.modal-objetivos__nome {
    flex: 1;
    min-width: 0;
}

.modal-objetivos__acoes {
    display: flex;
    gap: 0.75rem;
    flex-shrink: 0;
}

.modal-objetivos__acoes i {
    cursor: pointer;
    color: var(--cor-fonte-fraca, #888);
}

.modal-objetivos__acoes .bi-trash:hover {
    color: var(--cor-erro, #c0392b);
}
</style>
